import { tv } from '~/utils/tv'

export const paginationEllipseVariants = tv({
  base: [
    'flex h-large w-medium items-center justify-center max-sm:hidden',
    'text-center font-bold font-rdmodern text-threeandhalfpulse leading-small tracking-default',
  ],
})
